
/* eslint-disable global-require */
const Dashboard = r => require.ensure([], () => r(require('./Main')), 'dashboard-bundle')

export default [
  {
    name: 'dashboard.index',
    path: '/',
    component: Dashboard,
    meta: { requiresAuth: true }
  }, {
    name: 'catchall',
    path: '*',
    component: Dashboard,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/app/dashboard/routes.js